import React from 'react'

// style
import { Menu } from './style'

const ClassMenu = ({ ClassItems }) => {

  return (
    <Menu>
      {ClassItems}
    </Menu>
  )
}
export default ClassMenu